function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "lock");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "UniCafe-PWA-Layouts-MVP",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "square"
}, /*#__PURE__*/React.createElement("g", {
  id: "Info",
  transform: "translate(-31.000000, -568.000000)",
  stroke: "#155C28"
}, /*#__PURE__*/React.createElement("g", {
  id: "Button/Area-Selection-Copy-3",
  transform: "translate(10.000000, 554.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "lock",
  transform: "translate(22.000000, 15.000000)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  x: 5,
  y: 11,
  width: 9,
  height: 5
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.5,10 L7.5,7 C7.5032948,5.89679813 8.39679813,5.0032948 9.5,5 L9.5,5 C10.6032019,5.0032948 11.4967052,5.89679813 11.5,7 L11.5,10",
  id: "Path"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19,13.1428572 C19,18.5868069 14.7467051,23 9.5,23 C4.25329493,23 0,18.5868069 0,13.1428572 L0,2.1904762 L9.5,0 L19,2.1904762 L19,13.1428572 Z",
  id: "Path"
})))));

var SvgLock = function SvgLock(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "21px",
    height: "25px",
    viewBox: "0 0 21 25",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLock, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/lock.f15dd083.svg";
export { ForwardRef as ReactComponent };